/**
 * File messageBox.js
 * Description: File dùng trung gian để gọi thông báo
 * creatd by: nntam - 16/8/2019
 */
import Vue from 'vue';
import MsMessageBoxV2 from '@/components/msMessageBox/MsMessageBoxV2';
import i18n from '@/i18n/i18n';
class MessageBox {
	show(option) {
		let promise = new Promise((resolve, reject) => {
			const me = this;
			// cấu hình button mặt định
			let btnConfigDefault = [
				{
					key: 'Download',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Download')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'Cancel',
					hasBtn: false,
					target: 'Left',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					typeButton: 'secondary'
				},
				{
					key: 'Close',
					hasBtn: false,
					target: 'Center',
					text: `${i18n.t('i18nCommon.Close')}`,
					typeButton: 'primary'
				},
				{
					key: 'Yes',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Agree')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'Delete',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Delete')}`,
					typeButton: 'delete',
					focus: true
				},
				{
					key: 'No',
					hasBtn: false,
					target: 'RightFirst',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					typeButton: 'secondary'
				},
				{
					key: 'UnConnect',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.DisConnect')}`,
					typeButton: 'primary',
					focus: true
				},
				{
					key: 'PermissionGuild',
					hasBtn: false,
					target: 'Left',
					text: `${i18n.t('i18nCommon.PermissionGuild')}`,
					typeButton: 'nine',
					icon: 'mi-new-v2 mi-20 mi-icon-v2-help-blue-20'
				},
				{
					key: 'UploadXml',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.UploadXml')}`,
					typeButton: 'secondary',
					focus: true
				}
			];

			// merge cấu hình người dùng với cấu hình mặc định
			// nntam - 16/04/2020: bổ sung thêm truyền vào loại button (typeButton)
			if (option.btnConfig != null) {
				btnConfigDefault.forEach(element => {
					element.hasBtn = false;
					option.btnConfig.forEach(e => {
						if (element.key === e.key) {
							element.target = e.target;
							element.hasBtn = true;
							element.text = e.text ? e.text : element.text;
							element.focus = e.focus;
							element.typeButton = e.typeButton ? e.typeButton : element.typeButton;
							element.callback = e.callback;
							element.icon = e.icon ? e.icon : element.icon ? element.icon : '';
							element.class = e.class ? e.class : element.class;
							element.style = e.style ? e.style : element.style;
						}
					});
				});
			}

			// gán lại cấu hình mặc định với các tham số người dùng gửi vào
			let optionDefault = {
				message: option.message,
				textAlignMessage: option.textAlignMessage,
				messageDetail: option.messageDetail ? option.messageDetail : '',
				icon: option.icon == false ? false : option.icon ? option.icon : 'mi-icon-waring-55',
				line: option.line == false ? false : true,
				btnConfig: btnConfigDefault,
				closeMessageAfterLink: option.closeMessageAfterLink,
				close: option.close,
				width: option.width ? option.width : '444px',
				title: option.title ? option.title : null,
				isClose: option.isClose ? option.isClose : false,
				hiddenBorderHeader: option.hiddenBorderHeader ? option.hiddenBorderHeader : false,
				classMessageContent: option.classMessageContent ? option.classMessageContent : '',
				isMinHeightDynamic: option.isMinHeightDynamic ? option.isMinHeightDynamic : false,
				noClassPaddingBottom: option.noClassPaddingBottom ? option.noClassPaddingBottom : '',
				classContent: option.classContent ? option.classContent : '',
				maxHeight: option.maxHeight ? option.maxHeight : '',
				maxHeightMessage: option.maxHeightMessage ? option.maxHeightMessage : '',
				optionsCustom: option.optionsCustom ? option.optionsCustom : {},
				isIconClose: option.isIconClose
			};

			let zz = new Vue({
				i18n: i18n,
				el: '#message-box',
				render: function (h) {
					return (
						<MsMessageBoxV2
							ref="msgBox"
							option={optionDefault}
						//  {...vv}
						>
							{' '}
						</MsMessageBoxV2>
					);
				},
				computed: {},
				methods: {},
				components: {
					MsMessageBoxV2
				}
			});
			// nhận sự kiện click vào button
			let msgBox = zz.$refs.msgBox;
			if (msgBox) {
				msgBox.$on('btnClick', function (msg, action) {
					resolve(action);
				});
				// hngiap - 26.05.2020: Bổ sung callback thêm tham số resolve, reject để
				// - Xử lý trường hợp await action của msgBox cần resolve để chạy tiếp
				msgBox.$on('linkActive', function () {
					resolve('linkActive');
				});

				msgBox.$on('btnCloseClick', function () {
					resolve('btnCloseClick');
				});

				msgBox.$on('linkPopup', this.customLinkPopup);
				let firstBtn = msgBox.$el.querySelector('button');
				if (firstBtn) {
					firstBtn.focus();
				}
			}
		});

		return promise;
	}
	/**
	 * Hàm hiện thị message box xác nhận
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showCloseForm(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			isIconClose: true,
			btnConfig: [
				{
					key: 'Close',
					target: 'Right',
					text: `${i18n.t('i18nCommon.Close')}`
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận
	 * @param {Message cần hiển thị ra} message
	 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
	 */
	async showConfirmDelete(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			isIconClose: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					class: 'btn-cancel'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Delete')}`,
					focus: true,
					class: 'btn-delete',
					typeButton: 'delete'
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
	 * Hàm hiện thị message box xác nhận
	 */
	async showConfirm(message, customOptions) {
		// cấu hình mặc định với msg confirm
		let option = {
			message: message,
			isIconClose: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Cancel')}`,
					class: 'btn-cancel'
				},
				{
					key: 'Yes',
					hasBtn: false,
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Agree')}`,
					typeButton: 'primary',
					focus: true
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	/**
		 * Hàm hiện thị message box câu hỏi
		 * @param {Message cần hiển thị ra} message
		 * @param {Mesage chi tiết cần hiện, khi ẩn mở rộng và thu gọn} messageDetail
		 */
	showQuestion(message, customOptions) {
		// cấu hình mặc định với msg Question
		let option = {
			message: message,
			isIconClose: true,
			btnConfig: [
				{
					key: 'No',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.ClosePop')}`,
					typeButton: 'secondary'
				},
				{
					key: 'Yes',
					target: 'RightSecond',
					text: `${i18n.t('i18nCommon.Agree')}`,
					focus: true,
					typeButton: 'primary'
				}
			]
		};
		if (customOptions) {
			option = { ...option, ...customOptions };
		}
		return this.show(option);
	}

	close() {
		// Tìm msgBox instance hiện tại và đóng nó
		const msgBoxEl = document.querySelector('#message-box');
		if (msgBoxEl) {
			const vueInstance = msgBoxEl.getVueInstance();
			if (vueInstance) {
				vueInstance.isShowMessage = false;
			}
		}
	}
}

export default new MessageBox();
